<script>
  import { navigateTo } from "yrv";
  import { db } from "../firebase";
  import * as firebase from "../firebase";
  import { collectionData } from "rxfire/firestore";
  import { startWith } from "rxjs/operators";
  import Map from "./Map.svelte";
  import * as timeago from "timeago.js";
  import Save16 from "carbon-icons-svelte/lib/Save16";
  import { onMount, onDestroy } from "svelte";
  import Loader from "./Loader.svelte";
  import { scale } from "svelte/transition";

  export let mapid;
  export let uid;
  let mapdata;
  let mod;
  let checkUpdates;
  let promise = getMap(mapid);
  let savedData;

  $: owned = mapdata && mapdata.uid === uid

  async function getMap(mapid) {
    const mapRef = db.collection("maps").doc(mapid);
    const doc = await mapRef.get()
    if (doc.exists) {
      console.log("Document data:", doc.data());
      mapdata = doc.data();
      savedData = JSON.stringify(mapdata)
      checkUpdates = setInterval(checkForUpdates, 3000);
    } else {
      // doc.data() will be undefined in this case
      console.log("No such document!");
    }
  }

  function convertDate(timestamp){
    return timeago.format(new Date(timestamp));
  }


  function updateMap() {
    console.log("updateMap()");
    savedData = JSON.stringify(mapdata)
    try {
      db.collection("maps")
        .doc(mapid)
        .update({ map: mapdata.map, title: mapdata.title, description: mapdata.description,shared: mapdata.shared, updated:Date()})        
    } catch (error) {
      console.error(error);
    }
  }

  function handleMessage(event) {
    updateMap();
  }

  onDestroy(() => {
    clearInterval(checkUpdates);
  });

  function checkForUpdates() {
    // console.log("checkForUpdates...");
    if (JSON.stringify(mapdata) !== savedData) {
      console.log("time to save!");
      updateMap()
    }
  }
</script>

<style>
  /* .mapWrapper {
    margin: 20px;
    box-shadow: 2px 4px 4px rgba(0, 0, 0, 0.25);
  } */

  @media only screen and (max-width: 600px) {
  .mapWrapper {
    margin: 0px;
    box-shadow: none;
  }
}
</style>

{#await promise}
  <Loader />
{:then}
  <div class="mapWrapper">    
    <Map
      created={convertDate(mapdata.created)}
      owned={owned}
      mapuid={mapdata.uid}
      bind:updated={mapdata.updated}
      bind:data={mapdata.map}
      bind:title={mapdata.title}    
      bind:description={mapdata.description}  
      bind:shared={mapdata.shared}
      on:message={handleMessage} />
  </div>  
{:catch error}
  <p>{error.message}</p>
{/await}
